import { getWordCount } from '@Common/handlers/helper';
import QuillEditor, { QuillEditorIDS } from '@Common/handlers/quillEditor';
import wordCounterTrack from './track';

export const handleHotKeys = (event: KeyboardEvent) => {
  if (window.location.pathname !== '/word-counter') {
    return;
  }
  // Ctrl + Enter => Fix All Errors
  if ((event.ctrlKey || event.metaKey) && event.key === 'v') {
    wordCounterTrack.userPastedText(
      QuillEditor.getInstance(QuillEditorIDS.WORD_COUNTER_EDITOR)?.getContent('text') || '',
      getWordCount(
        QuillEditor.getInstance(QuillEditorIDS.WORD_COUNTER_EDITOR)?.getContent('text') || ''
      ) || 0
    );
  }
  if ((event.ctrlKey || event.metaKey) && event.key === 'c') {
    wordCounterTrack.clickedCopyButton(
      QuillEditor.getInstance(QuillEditorIDS.WORD_COUNTER_EDITOR)?.getContent('text') || '',
      'hotkey'
    );
  }
};
